export class Google {
  static readonly MAPS = 'AIzaSyDE9EyV9jZNhkoIDxzBwFmKyczffty3uM8';
  static readonly RECAPTCHA = '6Ldo-nAjAAAAAAo3CgdXrMHxfyhi7VmDnArs0Awp';
}
